import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";

const TABS = [
  {
    key: "cli",
    label: "CLI",
    badge: null,
    code: `# install the local engine (100% on-device)
pip install upii

# build memory from a folder — idempotent, content-addressed
upii ingest ./notes --recursive

# ask: cited, offline, zero bytes leave the device
upii ask "what did we agree on latency?"`,
  },
  {
    key: "mcp",
    label: "MCP",
    badge: "soon",
    code: `// give any agent private, cited memory — corpus stays local
{
  "mcpServers": {
    "smritium": { "command": "upii", "args": ["mcp"] }
  }
}

// tools: smritium_search · smritium_ask · smritium_list_sources
// returns only user-approved, attributed chunks`,
  },
  {
    key: "answer",
    label: "Cited answer",
    badge: null,
    code: `$ upii ask "what did we agree on latency?"

Answer: A 6-hour delivery SLA, relaxed to 12h during the pilot.

Sources:
  [1] meetings/sync.md      (chunk a3f2c9)
  [2] contracts/terms.md    (chunk 77d01b)

✓ answered offline · 0 bytes left the device`,
  },
];

export default function CodeTabs() {
  const [active, setActive] = useState("cli");
  const [copied, setCopied] = useState(false);
  const tab = TABS.find((t) => t.key === active);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(tab.code);
    } catch {
      /* clipboard unavailable */
    }
    setCopied(true);
    toast.success("Copied to clipboard");
    setTimeout(() => setCopied(false), 1600);
  };

  return (
    <div
      className="overflow-hidden rounded-2xl border border-white/10 bg-black/50 backdrop-blur-sm"
      data-testid="code-tabs"
    >
      <div className="flex items-center justify-between border-b border-white/10 px-3">
        <div className="flex">
          {TABS.map((t) => (
            <button
              key={t.key}
              onClick={() => setActive(t.key)}
              className={`relative px-4 py-3 font-mono text-xs transition-colors ${
                active === t.key ? "text-paper" : "text-mute hover:text-paper"
              }`}
              data-testid={`code-tab-${t.key}`}
            >
              {t.label}
              {t.badge && (
                <span className="ml-1.5 rounded-full bg-ember/15 px-1.5 py-0.5 text-[9px] uppercase tracking-wide text-ember">
                  {t.badge}
                </span>
              )}
              {active === t.key && (
                <span className="absolute inset-x-2 -bottom-px h-0.5 rounded-full bg-ember" />
              )}
            </button>
          ))}
        </div>
        <button
          onClick={copy}
          className="flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-xs text-mute transition-colors hover:text-paper"
          data-testid="code-copy-button"
        >
          {copied ? (
            <>
              <Check size={13} className="text-ember" /> Copied
            </>
          ) : (
            <>
              <Copy size={13} /> Copy
            </>
          )}
        </button>
      </div>
      <pre className="overflow-x-auto px-5 py-5 font-mono text-[12.5px] leading-relaxed text-paper/90">
        <code>{tab.code}</code>
      </pre>
    </div>
  );
}
